import { render, staticRenderFns } from "./AdminCreateProject.vue?vue&type=template&id=babbef40&scoped=true&"
import script from "./AdminCreateProject.vue?vue&type=script&lang=js&"
export * from "./AdminCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateProject.vue?vue&type=style&index=0&id=babbef40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babbef40",
  null
  
)

export default component.exports